module.exports = __webpack_public_path__ + "img/antOutline-area-chart.3c2225b1.svg";